import { ContractDetailsLineItem } from '~/common/types';

export enum ContractDetailsDataGridField {
  ID = 'id',
  POSITION = 'position',
  TITLE = 'title',
  UNIT = 'unit',
  PRICE_PER_UNIT = 'pricePerUnit',
  CURRENCY = 'currency',
  PLANNED_QUANTITY = 'plannedQuantity',
  PLANNED_VOLUME = 'plannedVolume',
  DESCRIPTION = 'description',
}

export type ContractDetailsDataGridRow = ContractDetailsLineItem;
